export default class StickyScroll {
  constructor(el) {
    this.el = el;

    const globalHeaderEl = document.querySelector('[data-header]');
    const globalBackToTopEl = document.querySelector('[data-back-to-top]');
    const stickyEl = el.querySelector('[data-sticky-content]');

    if (window.location.hash) {
      const elementId = window.location.hash.split('#');
      const headerEl = document.querySelector('[data-header]');
      const contentEl = document.getElementById(elementId[1]);

      if (contentEl) {
        history.replaceState(
          {},
          document.title,
          window.location.href.split('#')[0]
        );

        window.scrollTo({
          left: 0,
          top: contentEl.offsetTop - headerEl.getBoundingClientRect().height,
          behavior: 'smooth',
        });
      }
    }

    if (window.screen.width >= 1024) {
      window.addEventListener('scroll', function () {
        if (
          stickyEl.parentNode.offsetTop >=
          this.window.scrollY + globalHeaderEl.offsetHeight
        ) {
          stickyEl.style.top = null;
          stickyEl.style.maxHeight = null;
        } else if (
          window.scrollY >=
          stickyEl.offsetTop - globalHeaderEl.offsetHeight
        ) {
          stickyEl.style.top = `${globalHeaderEl.offsetHeight}px`;
          stickyEl.style.maxHeight = `calc(100vh - ${globalHeaderEl.offsetHeight}px)`;
        }
      });
    } else {
      globalBackToTopEl.style.bottom = '5rem';
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/StickyScroll.js